/**
 * Filters the link items of a link block on measurement type (metric/imperial).
 *
 * The initial state is rendered server side, so this only reacts to clicks. Items without a
 * measurement type carry no value and are never hidden.
 */
const HIDDEN_CLASS = 'link-block__link-item--hidden';
const CURRENT_CLASS = 'link-block__segmented-button--current';

document.querySelectorAll('[data-link-block-filter]').forEach((filter) => {
  const buttons = filter.querySelectorAll('[data-link-block-filter-value]');
  const items = filter
    .closest('.link-block')
    ?.querySelectorAll('[data-link-block-filter-item]');

  if (!items?.length) {
    return;
  }

  filter.addEventListener('click', (event) => {
    const button = event.target.closest('[data-link-block-filter-value]');

    if (!button) {
      return;
    }

    const value = button.dataset.linkBlockFilterValue;

    items.forEach((item) => {
      const measure = item.dataset.linkBlockFilterItem;
      item.classList.toggle(HIDDEN_CLASS, !!measure && measure !== value);
    });

    buttons.forEach((item) =>
      item.classList.toggle(CURRENT_CLASS, item === button)
    );
  });
});
